define('helpers',['app/views/vue/store/store','moment','underscore','hbs!app/views/templates/navbar','showdown', 'jquery'],function(store,moment,_,navbarTpl,showdown, $){
    return {
        configFromUrl: {},
        bookingWindowData: {},
        promiseRef: null,
        location:app.models.spaModel.getData("spaLocations",{}),
        bookingResponseTemplate : {
            "diningBooking": {
                Label: {
                    Location: 'DiningVenue',
                    GuestRequest: 'SpecialRequests',
                    dateTime: 'DateTime'
                },
                data: {
                    PartySize: '',
                    Reference: ''
                }
            },
            "golfBooking": {
                Label: {
                    Location: 'CourseId',
                    dateTime: 'BookingTime'
                },
                data: {
                    Position: '',
                    players: 0
                }
            },
            "spaBooking": {
                Label: {
                    Location: 'LocationName',
                    GuestRequest: 'GuestRequest',
                    dateTime: 'BookStartTime'
                },
                data: {
                    Room: '',
                    ServiceTime: ''
                }
            },
            "pmsBooking": {
                Label: {
                    Location: 'Venue',
                    GuestRequest: 'GuestRequest',
                    dateTime: 'ArrivalDate'
                },
                data: {
                    Nights: 0,
                    NumAdults: 0,
                    NumChildren: 0,
                    NumYouth: 0,
                    PMSRoomNumber: '',
                    folioid: ''
                }
            }
        },
        addGroupMember: function (userFirstName, userLastName ) {
            var dfd = $.Deferred();
            var paramPrefix = '',
                ccParams = {};
            var self = this;
            ccParams["CustomerId"] = app.data.CustomerId;
            ccParams["CustomerGUID"] = app.data.CustomerGUID;
            paramPrefix = 'NewGroupMember.'
            ccParams[paramPrefix + "Name.FirstName"] = userFirstName,
            ccParams[paramPrefix + "Name.LastName"] = userLastName,
            $.when(app.models.systemModel.getData('createGroupMember', ccParams))
                .then(function (r_cc) {
  
                    dfd.resolve({message: app.localization.newUser.successMember, newUserId: r_cc.NewGroupMemberCustomerId });
              
                    
                //recent fix for the age restriction logic. There always a single user to begin with. And my age restriction check automatically runs moment the user clicks on the service. If the user didn't meet the age requirement, my schedule btn is disabled. When there is more than 1 user, then the guest has to click on the checkbox to run select it. The issue that was happening is at this point if you add another user which meets the age requirement, btn would still be disabled because previously it ran for the first user automatically and that has to be removed
                if(_.keys(store.state.users).length == 1 && _.isEmpty(store.state.users[_.keys(store.state.users)[0]])){
               
                store.commit('setScheduleBtnValidity', {
                          action: "remove",
                          removeAll: true
                  })
                 }
                 store.commit('addGroupMember',userFirstName+" "+userLastName);
                 if(!(Customization.spaBooking.onetimeBookerLocations && _.isArray(Customization.spaBooking.onetimeBookerLocations) && Customization.spaBooking.onetimeBookerLocations.indexOf(app.data["selected/spa/spaLocations/SpaLocation/"]) > -1)) store.commit('addUser',{userId: r_cc.NewGroupMemberCustomerId});
                 store.commit('addUserWithId',{name: userFirstName+" "+userLastName, id: r_cc.NewGroupMemberCustomerId});

                //as a part of age restrictions, I am storing guest profile in the state.guestProfiles. Since it doesnt return the actual profile back, I will create an object with necessery fields needed. Will find better way to store later on. At this point I am avoiding calling fetchGroupMember call again.
                self.fetchGroupMembers().then(function (groupMembers) {
                    groupMembers.GroupMember.forEach(function (member) {
                      if(member.CustomerId ==r_cc.NewGroupMemberCustomerId ){
                        var modifedProfile = _.extend({}, store.state.guestProfiles[member.CustomerId], member)
       
                      store.commit('addGuestProfile',modifedProfile)
                      }
                    })
                });
                })
                .fail(function (r_cc) {
                    dfd.reject(app.localization.newUser.fail);
                })
            return dfd.promise();
        },
        fetchSpaStaff: function(SpaItemId){
           return app.models.spaModel.getData('spaStaff', {SpaItemId:SpaItemId})
            .then( function(r_sc) {
                return r_sc.SpaStaff
            })
        },
        getSelectedLocation:function(){
            return app.models.spaModel.getSelectedItem('spaLocations', {})
         
        },
        // fetchFutureSpaBookings: function(){
        //     return app.data.spaBookings
        // },
        fetchGroupMembers: function(){
            var dfd = $.Deferred();
            app.models.userModel.getData('fetchGroupMembers', {
                CustomerId: app.data.CustomerId,
                CustomerGUID: app.data.CustomerGUID
            }).then(function (groupMembers) {
                dfd.resolve(groupMembers);
            }, function (err) {
                dfd.resolve( {
                    GroupMember: []
                });
            })
            // .always(function (groupMembers) {
            //     groupMembers.GroupMember.forEach(function (member) {
            //         store.commit('addGroupMember',member.Name.FirstName + " " + member.Name.LastName);
            //         store.commit('addUserWithId',{name: member.Name.FirstName + " " + member.Name.LastName, id: member.CustomerId});
            //     })
            // });
            return dfd.promise();
        },
        fetchLoggedInCustomerProfile: function(){
            var dfd = $.Deferred();
            app.models.userModel.getData('fetchCustomerProfile', {
                CustomerId: app.data.CustomerId,
                CustomerGUID: app.data.CustomerGUID
            }).then(function (profile) {
                dfd.resolve(profile);
            }, function (err) {
                dfd.resolve( err);
            })
            return dfd.promise()
        },
        updateUserDob: function(dob,guestCustomerId){
            var dfd = $.Deferred();
           
            var params = {
                "Customer.CustomerId": app.data.CustomerId,
                "Customer.CustomerGUID": app.data.CustomerGUID,
                "Customer.DateOfBirth":dob? moment(dob).format('YYYY-MM-DD'): ''
            }
             !!guestCustomerId && guestCustomerId != app.data.CustomerId? params["Customer.CustomerToChange"]=guestCustomerId:''
            app.models.systemModel.getData('updateCustomerProfile', params).then(function (profile) {
                dfd.resolve(profile);
            }, function (err) {
                dfd.reject( err);
            })
            return dfd.promise()
        },
        fetchSpaClassesAndPackages: function(){
            return app.models.spaModel.getData('spaServices', {}).then(function(spaServicesData){
                // Removes Package Items on selected locations
                if(Customization.spaBooking.hideSpaPackageItemsOnLocations && _.isArray(Customization.spaBooking.hideSpaPackageItemsOnLocations) && Customization.spaBooking.hideSpaPackageItemsOnLocations.indexOf(app.data["selected/spa/spaLocations/SpaLocation/"]) > -1) {
                    delete spaServicesData.SpaPackages;
                }
                var res = {packages:{},services:[]}
                var temp = {};
                if(!!spaServicesData.SpaPackages){
                    spaServicesData.SpaPackages.forEach(function (packageArr){
                        [].concat(packageArr.SpaPackage).forEach(function(packageItem){
                            if(!packageItem.SpaItemId) packageItem.SpaItemId = packageItem.SpaPackageId;
                            if(!packageItem.ItemName) packageItem.ItemName = packageItem.PackageName;
                            if(!packageItem.LocationId) packageItem.LocationId = app.models.spaModel.getSelectedItem('spaLocations').LocationId;
                            packageItem.type = 'package'
                            res.packages[packageItem.SpaPackageId] = packageItem;
                            if(!temp[packageItem.PackageCategory])
                                temp[packageItem.PackageCategory] = {name:packageItem.PackageCategory,value:[]}
                            temp[packageItem.PackageCategory].value.push(packageItem);
                        })
                    })
                }
                (spaServicesData.SpaService|| []).forEach(function(service){
                    if(!service.LocationId) service.LocationId = service.Location || app.models.spaModel.getSelectedItem('spaLocations').LocationId;
                    service.type = 'service';
                    var category = service.ItemCategory;
                    if(!temp[category])
                        temp[category] = {name:category,value:[]}
                    temp[category].value.push(service);
                });
                res.services = _.values(temp);
                return res;
            }).fail(function(e){
                console.log("spa service fail",e)
            }).always(function(spaServicesData2){
                if(spaServicesData2 && spaServicesData2.Result && spaServicesData2.Result.value == 'FAIL'){
                    store.commit('removeAllCategories');
                    store.commit('clearAllServicesAndPackages');
                    store.commit('addGlobalMessage',{type:'warn',message:app.localization.spaBooking.packageBooking.errors.noServiceReturn})
                    return {packages:{},services:[]};
                }                
            })   
        },
        loginUser: function (email, password, mode) {
            var Vm = this;
            var params = {};
            var deferred = $.Deferred();
            var emailMode = mode==app.localization.spaBooking.packageBooking.login.ui.placeholders.emailMode.emailField;
            var folioMode = mode==app.localization.spaBooking.packageBooking.login.ui.placeholders.folioMode.emailField;
            if(emailMode){
                app.data.lastLoginEmail = email;
                app.data.lastLoginPassword = password;
                params.EmailAddress = email.toLowerCase();
                params.Password = password;
            }else if(folioMode){
                params.FolioId = email;
                params.LastName = password.toUpperCase();
            }
            $.when(
                app.models.userModel.getData('authCustomer', params)
                || (function () { var d = $.Deferred(); d.reject(false); return d })()
            )
            .done(function (r_l) {
                var dfd = $.Deferred();
              //  if(folioMode) {
                    app.models.userModel.getData('fetchCustomerProfile', { CustomerId: r_l.CustomerId, CustomerGUID: r_l.CustomerGUID }).then(function(r_fcp){
                         //As a part of age restriction, it is required to call fetchCustomerProfile to fetch loggedIn user detail which has birthdate in it. Also clear schedulebtn validity list to give it a fresh start.
                         store.commit('setScheduleBtnValidity', {
                            action: "remove",
                            removeAll: true
                        })
                         if (r_fcp.Customer) {
                            var modifedProfile = _.extend({}, store.state.guestProfiles[r_fcp.Customer[0].CustomerId], r_fcp.Customer[0])
                            store.commit('addGuestProfile', modifedProfile)
                            delete store.state.guestProfiles[r_fcp.Customer[0].CustomerId].requireDatePicker
                        }
                        dfd.resolve(r_fcp);
                    });
               // }else {
                 //   dfd.resolve();
               // }
                // process r_l.customerId, etc here
                dfd.promise().then(function(r_fcp) {
                    //login success message
                    store.commit('addGlobalMessage',{type:'success',message:app.localization.general.login.loginSuccess})

                    app.datac('userLoggedIn', true);
                    app.datac('CustomerId', r_l.CustomerId);
                    app.datac('CustomerGUID', r_l.CustomerGUID);
                    app.datac('FirstName', r_l.FirstName);
                    app.datac('LastName', r_l.LastName);
                    app.datac('folioLoginHasPassword', emailMode ? null : r_l.HasPassword);
                    app.datac('RestrictedFolio', emailMode ? null : email);
                    app.datac('RestrictedLogin', emailMode ? null : true);
                    app.datac('CustomerEmail', emailMode ? email.toLowerCase() : r_fcp.Customer[0].EmailAddress.toLowerCase());

                    store.commit('setLoggedInUser',{userId: r_l.CustomerId});
                    store.commit('addUserWithId',{name: r_l.FirstName+" "+r_l.LastName, id: r_l.CustomerId});
                    store.commit('SetmobileViewMessages',{key:'success',message: app.localization.general.login.loginSuccess})
                    setTimeout((function(){
                        store.commit('SetmobileViewMessages',{key:'success',message: ""})
                    }), 3000)
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    if (!app.data.SessionId) {
                        window.location.reload(false);
                        return
                    }

                    $.when(
                        app.models.systemModel.getData('updateSession', { CustomerId: r_l.CustomerId, CustomerGUID: r_l.CustomerGUID }),
                        app.controllers.initController.initGuestItinerary()
                    )
                        .done(function (r_us) {
                            Vm.updateNavBar();
                            Vm.fetchGroupMembers().then(function (groupMembers) {
                                groupMembers.GroupMember.forEach(function (member) {
                                    store.commit('addGroupMember',member.Name.FirstName + " " + member.Name.LastName);
                                    store.commit('addUserWithId',{name: member.Name.FirstName + " " + member.Name.LastName, id: member.CustomerId});
                                    //part of age restriction
                                    var modifedProfile = _.extend({}, store.state.guestProfiles[member.CustomerId], member)
                                    store.commit('addGuestProfile',modifedProfile)
                                })
                            });
                            deferred.resolve();
                            if (r_l.ResetPwd == 'Y') {
                                app.data.messages.push({
                                    type: 'alert', 'class': 'alert-error', actions: [],
                                    title: app.localization.general.login.err.newPasswordRequired
                                });
                                app.dispatcher.dispatch.apply(app.dispatcher, ['profile', 'change', [eventName, password, r_us.ConflictingSpaBookingRemoved == 'Y']])
                            } else {
                                if (r_us && r_us.ConflictingSpaBookingRemoved == 'Y') {
                                    // app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                    //     title:app.localization.general.conflictingSpaBookingRemovedTitle,
                                    //     message:app.localization.general.conflictingSpaBookingRemoved
                                    // });
                                    store.commit('addGlobalMessage',{type:'warn',message:app.localization.general.conflictingSpaBookingRemoved})
                                    return
                                }
                            }
                        })
                        .fail(function (r_us, r_fb) {
                            window.location.reload(false);
                        })
                }, function(){
                    //login failiure
                    store.commit('addGlobalMessage',{type:'warn',message:app.localization.general.login.err.invalidCredentials})
                })
            })
            .fail(function (r_l) {
                deferred.reject(app.localization.general.login.err.invalidCredentials);
            })
            return deferred.promise();
        },
        goToSplash: function(authType){
            if(app.data.userLoggedIn){
                app.data.messages.push({ type:'alert', 'class':'alert-success', actions:[],
                            title: app.localization.auth.loginSuccess+' '+ (authType || '') +' account.',
                            message:''
                        });
                app.views.userView.event.fire('renderLoginVue', ['splash']);
            }
        },
        analyticsInit: function(event, args){
            app.commonViewHelper.analyticsInit(event, args);
        },
        loginAuthUser: function(idToken, engineType, userAuthData){
            var helpers = this;
            var deferred = $.Deferred();

            xhr = new XMLHttpRequest();
            xhr.open('POST','/auth', true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.onreadystatechange = function receiveResponse() {
                if (xhr.readyState == 4) {
                    var status = xhr.status;
                    if (status === 0 || (status >= 200 && status < 400)) {
                        var user = JSON.parse(xhr.response);
                        
                        if (Object.keys(user).length){    
                            if(user.UserCreated){
                                store.commit('addGlobalMessage',{type:'success',message:app.localization.auth.accountCreateSuccess+ engineType.toLowerCase() +' account.'});
                            } else store.commit('addGlobalMessage',{type:'success',message:app.localization.auth.loginSuccess+ engineType.toLowerCase() +' account.'});

                            store.commit('setScheduleBtnValidity', {
                                action: "remove",
                                removeAll: true
                            });         
                            var modifedProfile = _.extend({}, store.state.guestProfiles[user.CustomerId], user);
                            store.commit('addGuestProfile', modifedProfile);
                            delete store.state.guestProfiles[user.CustomerId].requireDatePicker;

                            app.datal('thirdPartyAuth', true);
                            app.datac('userLoggedIn', true);
                            app.datac('CustomerId',user.CustomerId);
                            app.datac('CustomerGUID', user.CustomerGUID);
                            app.datac('FirstName', user.FirstName);
                            app.datac('LastName', user.LastName);
                            app.datac('folioLoginHasPassword', null);
                            app.datac('RestrictedFolio',  null);
                            app.datac('RestrictedLogin', null);

                            app.datac('CustomerEmail', user.CustomerEmail);
                            store.commit('setLoggedInUser',{userId: user.CustomerId});
                            store.commit('addUserWithId',{name: user.FirstName+" "+user.LastName, id: user.CustomerId});
                            store.commit('SetmobileViewMessages',{key:'success',message: app.localization.general.login.loginSuccess});
                            setTimeout((function(){
                                store.commit('SetmobileViewMessages',{key:'success',message: ""});
                            }), 3000)
                            if (!app.data.SessionId) {
                                 window.location.reload(false);
                                return
                            }
                            
                            $.when( app.models.systemModel.getData('updateSession', { CustomerId: user.CustomerId, CustomerGUID: user.CustomerGUID }),
                                    app.controllers.initController.initGuestItinerary()
                            )
                            .done(function (r_us) {
                                helpers.updateNavBar();
                                helpers.fetchGroupMembers().then(function (groupMembers) {
                                    groupMembers.GroupMember.forEach(function (member) {
                                        store.commit('addGroupMember',member.Name.FirstName + " " + member.Name.LastName);
                                        store.commit('addUserWithId',{name: member.Name.FirstName + " " + member.Name.LastName, id: member.CustomerId});
                                        //part of age restriction
                                        var modifedProfile = _.extend({}, store.state.guestProfiles[member.CustomerId], member);
                                        store.commit('addGuestProfile',modifedProfile);
                                    })
                                });
                                deferred.resolve();
                                if (r_us && r_us.ConflictingSpaBookingRemoved == 'Y') {
                                    store.commit('addGlobalMessage',{type:'warn',message:app.localization.general.conflictingSpaBookingRemoved});
                                    return
                                }
                            })
                            .fail(function (r_us) {
                                window.location.reload(false);
                            })                           
                        }
                    } else vm.error = app.localization.auth.networkError;
                };
            }
            xhr.send(JSON.stringify({token: idToken, engineType:engineType, user:userAuthData, isAccessToken: engineType == 'GOOGLE' ? true : false}));

            return deferred.promise();

        },
        checkConflict: function(startTime,endTime,itemID,userId,SpaFolioItemIdsArr, refetch, ignoreExistingItemConflict){
            if(!userId) return false;
            var reservedTimes = store.state.reservedTimes[userId] || [];
            return reservedTimes.some(function(item){
                if((refetch || ignoreExistingItemConflict) && SpaFolioItemIdsArr.indexOf(item.SpaFolioItemId)>-1 ) return false;
                var rst = moment(item.StartTime,'YYYY-MM-DDHHmmss'),
                    ret = moment(item.EndTime,'YYYY-MM-DDHHmmss');
                if(itemID == item.SpaFolioItemId)
                    return (startTime.diff(rst)==0 && endTime.diff(ret)==0);
                return (startTime.diff(rst)==0 || endTime.diff(ret)==0 || (startTime.diff(rst)>0 && startTime.diff(ret)<0) || (endTime.diff(rst)>0 && endTime.diff(ret)<0) || (startTime.diff(rst)<0 && endTime.diff(ret)>0))
            })
        },
        fetchSpaAvailabilities: function(itemID,dateTime,duration,staffId, item, userId, itemIdWithTS, refetch ){
           
            var res = {data:[],staff:{},rooms:{},equipment:{}};
            var staffDict = {};
            [].concat(item.CapableStaff.Staff || []).forEach(function(staff){ staffDict[staff.id] = staff });
            var vm = this;
            if(!vm.bookingWindowData[item.SpaItemId]){
               // var location = app.models.spaModel.getSelectedItem('spaLocations', {});
               var location = vm.location
                vm.bookingWindowData[item.SpaItemId] = app.commonViewHelper.getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location,item))
            }
            return app.models.spaModel.getData('spaAvailabilityV2', { StartDateTime:dateTime, SpaItemId:itemID, Version:2, SpaStaffId:(isNaN(staffId) ? 0 : staffId), Refetch:refetch,IsForPackageItem:'N' }).then(function(spaServicesData){
                [].concat(spaServicesData.SpaAvailabilities[0].SpaAvailability).filter(function(avail){ return avail.StartTime.substring(0,10) == dateTime.substring(0,10) }).forEach(function(avail){
                    var conflict = (item.HasEquipment == 'Y' && avail.AvailableEquipment == 0) || avail.AvailableRooms == 0;
                    if(!conflict) conflict = !vm.checkBookable(itemID,avail.StartTime)
                    if(!conflict){
                        var st = moment(avail.StartTime,'YYYY-MM-DDHHmmss'),
                        et = moment(avail.EndTime,'YYYY-MM-DDHHmmss');
                        conflict = vm.checkConflict(st,et,itemID,userId,[item.SpaFolioItemId],refetch);
                    }
                    if(!conflict) res.data.push({ StartDateTime:avail.StartTime, endDateTime:avail.EndTime, startTime:st.format('hh:mm a') })
                    if(!conflict) {
                        if(!res.staff[item.SpaItemId]) res.staff[item.SpaItemId] = {allStaff:{}};
                        if(!res.equipment[item.SpaItemId]) res.equipment[item.SpaItemId] = {};
                        res.equipment[item.SpaItemId][avail.StartTime] = avail.AvailableEquipment;
                        // resObj.staff[item.SpaItemId].allStaff
                        [].concat(avail.SpaStaffs.SpaStaff).forEach(function(staff){
                            res.staff[item.SpaItemId].allStaff[staff.SpaStaffId] = true;
                        })
                        if(!res.staff[item.SpaItemId][avail.StartTime]) res.staff[item.SpaItemId][avail.StartTime] = [].concat(avail.SpaStaffs.SpaStaff).map(function(staff){ return _.extend(staff,staffDict[staff.SpaStaffId]) });
                        if(!res.rooms[item.SpaItemId]) res.rooms[item.SpaItemId] = {};
                        if(!res.rooms[item.SpaItemId][avail.StartTime]) res.rooms[item.SpaItemId][avail.StartTime] = avail.AvailableRooms;
                    }
                })
            //     if(parseInt(staffId)){
            //       var result = res.data.filter(function(staff){
            //         return staff.SpaStaffId == staffId
                    
            //     })  
            //     if(result.length>0) res.data = result    

            // }
           
                return res;
                
            },function(res){
                // if (res.Result.ErrorId == "401")
                return $.Deferred().reject(res)
                // else it will stay a rejected promise
            })
        },
        checkBookable: function(serviceId,spaClassStartTime){
            var bookingWindow = this.bookingWindowData[serviceId];
            var startTime = moment.tz(spaClassStartTime, 'YYYY-MM-DDHHmm', bookingWindow.timeZone);
            var endMinTime = startTime.clone()
            if (!_.isEmpty(bookingWindow.endOffset)) {
                endMinTime.add(bookingWindow.endOffset)
            }
            if (!_.isEmpty(bookingWindow.endSet)) {
                _.each(bookingWindow.endSet, function (num, unit) {
                    endMinTime[unit](num)
                })
            }
            var startMaxTime = moment('2000-01-01')
            if (!_.isEmpty(bookingWindow.startOffset)) {
                startMaxTime = startTime.clone()
                startMaxTime.add(bookingWindow.startOffset)
            }
            if (!_.isEmpty(bookingWindow.startSet)) {
                _.each(bookingWindow.startSet, function (num, unit) {
                    startMaxTime[unit](num)
                })
            }

            var now = moment.tz(bookingWindow.timeZone);
            return endMinTime > now && startMaxTime <= now
        },
        updateNavBar: function(){
            //below code is commented as it is not required to reset the navbar ui ref #11142
              $('#nav').html( navbarTpl( {
                Customization:app.customization,
                Localization : app.localization,
                services : app.data.serviceTypes,
                languages : app.data.languageNames,
                siteName : app.localization.siteName,
                backLink : Customization.serverURL
            }) );
            $('#nav a.skip-main').on('click', function (e) {
                e.preventDefault();
                $('#main .focus-first').focus();
            })
            var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
                return a.id == app.views.spaView.module
            }));
            app.models.systemModel.getData('folioBalance', {}).then(function (folioBalanceData) {
                app.commonViewHelper.updateNavBar(service, app.language, folioBalanceData);
            })
        },
        fetchFolioBookings: function(){
            return app.models.systemModel.getData('folioBookings', {}).then(function(data){
                var res = {raw:data,formatted:{}};
                (data.WebFolioItem||[]).filter(function(item){ return item.PackageType == "PH" }).forEach(function(item){
                    item.packageItems = [];
                    res.formatted[item.FolioItemId] = item;
                });
                (data.WebFolioItem||[]).forEach(function(item){
                    if(item.PackageType != "PI"){
                        res.formatted[item.FolioItemId] = item;
                    }else {
                        var itemDuration = moment(item.FinishDate,'YYYY-MM-DDHHmmss').diff(moment(item.StartDate,'YYYY-MM-DDHHmmss'),'minutes');
                        item.duration = itemDuration;
                        if(!res.formatted[item.ParentItem].duration) res.formatted[item.ParentItem].duration = 0;
                        res.formatted[item.ParentItem].duration = +res.formatted[item.ParentItem].duration + +itemDuration;
                        res.formatted[item.ParentItem].packageItems.push(item);
                    }
                });
                return res;
            });
        },
       updateCalender: function (CustomerId, CustomerName) {
           var vm = this
           var events = [];
           var currentUserId = CustomerId  || app.data.CustomerId || app.data.DefaultCustomerId
           var username = store.state.usersWithIds[currentUserId]
           this.fetchFutureBookingsForUser(CustomerId || currentUserId).always(function (futureSpaBookings) {
            store.commit("setUserCalenderEvents", events); // clear it first
               // locic for adding furture bookings --start
               var futureBookingForUser = futureSpaBookings
               futureBookingForUser.forEach(function (bk) {
                   if (bk.isFutureBooking) {
                  
                       var obj = {
                           start: moment(bk.StartTime, "YYYY-MM-DDHHmmss").format("YYYY-MM-DD HH:mm"),
                           end: moment(bk.EndTime, "YYYY-MM-DDHHmmss").format("YYYY-MM-DD HH:mm"),
                           title: bk.activity,
                           status: bk.isFutureBooking ? "Booked" : app.localization.spaBooking.packageBooking.sideCart.bookingInCart,
                           class: bk.isFutureBooking ? bk.bookingType == "pmsBooking" ? 'health' : "leisure" : "sport",
                           content: '<i class="v-icon material-icons">shopping_cart</i>',
                           CustomerName: CustomerName || username,
                           LocationName: bk.LocationName,
                           formattedDateTime: bk.formattedDateTime,
                           GuestRequest: bk.GuestRequest,
                           bookingType: bk.bookingType,
                           allDay: bk.bookingType == "pmsBooking" ? true : false,
                       };
                       if (bk.bookingType == "diningBooking") {
                           vm.bookingResponseTemplate[bk.bookingType].data.PartySize = bk.PartySize
                           vm.bookingResponseTemplate[bk.bookingType].data.Reference = bk.Reference
                       } else if (bk.bookingType == "golfBooking") {
                           vm.bookingResponseTemplate[bk.bookingType].data.Position = bk.Position
                           vm.bookingResponseTemplate[bk.bookingType].data.players = bk.players
                       } else if (bk.bookingType == "spaBooking") {
                           vm.bookingResponseTemplate[bk.bookingType].data.Room = bk.Room
                           vm.bookingResponseTemplate[bk.bookingType].data.ServiceTime = bk.ServiceTime
                       } else if (bk.bookingType == "pmsBooking") {
                           vm.bookingResponseTemplate[bk.bookingType].data.Nights = bk.Nights
                           vm.bookingResponseTemplate[bk.bookingType].data.NumAdults = bk.NumAdults
                           vm.bookingResponseTemplate[bk.bookingType].data.NumChildren = bk.NumChildren
                           vm.bookingResponseTemplate[bk.bookingType].data.NumYouth = bk.NumYouth
                           vm.bookingResponseTemplate[bk.bookingType].data.PMSRoomNumber = bk.PMSRoomNumber
                           vm.bookingResponseTemplate[bk.bookingType].data.folioid = bk.folioid
                       }
                       _.extend(obj, vm.bookingResponseTemplate[bk.bookingType].data)
                       
                       //vue calender is not capable of handling same event across mutiple dates in a row. So for pms bookings I would have to create event for each night
                      
                       //pms num of night check end
                       events.push(obj);
                       store.commit("setUserCalenderEvents", events);
                   }
               });
            })
               // locic for adding furture bookings --end
               // locic for adding current session bookings --start
              
               vm.fetchFolioBookings().then(function (data) {
                   _.values(data.formatted).forEach(function (bk) {
                
                       if (bk.CustomerId == currentUserId && (bk.Category == 'Spa' || bk.Category == 'SpaWait')) {
                           if (bk.PackageType == 'PH') {
                               bk.packageItems.forEach(function (itemBooking) {
                                   events.push(createCurrentSessionEvent(itemBooking, currentUserId, (CustomerName || username)))
                               })
                           } else events.push(createCurrentSessionEvent(bk, currentUserId, (CustomerName || username)))
                       }
                   })
           
                    store.commit("setUserCalenderEvents", events,currentUserId);
               })
               function createCurrentSessionEvent(bk,currentUserId,username){
                var currentSessionBooking = {}
                    currentSessionBooking = {
                        start: moment(bk.StartDate, "YYYY-MM-DDHHmmss").format("YYYY-MM-DD HH:mm"),
                        end: moment(bk.FinishDate, "YYYY-MM-DDHHmmss").format("YYYY-MM-DD HH:mm"),
                        title: bk.Details,
                        status:( bk.Category == 'SpaWait'?"Waitlisted":"Reserved") + ", "+app.localization.spaBooking.packageBooking.sideCart.waitListInCart+"",
                        class: "sport",
                        content: '<i class="v-icon material-icons">shopping_cart</i>',
                        CustomerName:username,
                        LocationName: bk.Location,
                        GuestRequest: bk.GuestRequest,
                        bookingType: bk.Category == "Spa" || bk.Category == "SpaWait" ? 'spaBooking' : '',
                        allDay: bk.Category == "Hotel" ? true : false,
                        formattedDateTime: moment(bk.StartDate, 'YYYY-MM-DDHHmmss').format('ddd, MMM D @ hh:mm A')
                    };
                  return currentSessionBooking
                
               }
               // locic for adding current session bookings --end
        
       },
        removeService: function(FolioItemId,SpaItemId,service_key,userId,packageItem, service, otbCallback){
            var vm = this
            if(FolioItemId){
                FolioItemId= [FolioItemId];
                if(packageItem){
                    packageItem.PackageItems.PackageItem.forEach(function(item){
                        FolioItemId.push(item.SpaFolioItemId);
                    })
                }
                this.fetchFolioBookings().then(function(folioBookings){
                    var serviceBookings = _.filter(folioBookings.raw.WebFolioItem,function(item){ 
                        return FolioItemId.indexOf(item.FolioItemId) > -1 
                    });
                    removeInSeries(serviceBookings);
                });
            }else store.commit('removeSingleService',{ userId:userId, id:service_key, specific:true })

            function removeInSeries(bookingArr){
                
                var serviceBooking = bookingArr.pop();
                //needs refactoring
                app.controllers.cartController.removeItem((serviceBooking || {}).Category,serviceBooking.FolioId,serviceBooking.FolioItemId,true,_,_,_, false).then(function(){
                    if(store.state.activeStep == 2)store.commit('setForceUpdate',true);
                    store.commit('removeReservedTime',{ userId: userId, id:serviceBooking.ItemId, dateTime:serviceBooking.StartDate,FolioItemId:serviceBooking.FolioItemId });
                    if(service_key) store.commit('removeSingleService',{ userId:userId, id:service_key, specific:true });
                    if(bookingArr.length>0) removeInSeries(bookingArr);
                    if(bookingArr.length == 0) {
                        vm.updateCalender()
                        vm.updateNavBar();
                        store.commit('addGlobalMessage',{message:app.localization.spaBooking.packageBooking.messages.removedItemSuccessfully,type:'success',title:"Success!"})
                        store.commit('addService',{service:service,userId:userId,setSelected:true});                                
                        otbCallback();
                    }
                    // noor wanted to add something
                })
            }
        },
        
        fetchPackageAvailabilities: function(dateTime,pkgItemsArr,maxGap,existingBookings,userId, requiredItemID,staff,version,minGap, selectedStaffs, refetch, ignoreExistingItemConflict){
            var vm = this;
            var sort_levels;
            var lastPossibleEndTimesPerItem = {};
            var currentStartTimeNotPossibleForItems = {};
            pkgItemsArr.forEach(function(item){ currentStartTimeNotPossibleForItems[item.SpaItemId] = false });
            var package = {
                max_gap : maxGap,
                min_gap : minGap,
                components : {},
                SpaFolioItemIds: []
            };
            var params = {StartDateTime:dateTime};
            pkgItemsArr.forEach(function(item){
                package.components[item.SpaItemId] = {
                    itemid: item.SpaItemId,
                    duration: item.ServiceTime,
                    itemName: item.ItemName,
                    sort: item.BookOrder,
                    max_gap : item.MaxMinsBetweenBookings,
                    min_gap : item.MinMinsBetweenBookings,
                    staff:{},
                    processTime: item.ProcessTime
                };
                [].concat(item.CapableStaff.Staff || []).forEach(function(staff){
                    package.components[item.SpaItemId].staff[staff.id] = staff;
                })
                if(!!item.SpaFolioItemId) package.SpaFolioItemIds.push(item.SpaFolioItemId);
            });
            var resObj = {data:[],staff:{}};
            var staffObj = {};
                var availabilities  = {};
                // express all times as minutes since midnight
                // convert string time "19:32" as 19*60 + 32 = 1172
                // durations remain the same as in the api, eg 60
                pkgItemsArr.forEach(function(item){
                    if(!vm.bookingWindowData[item.SpaItemId]){
                      //  var location = app.models.spaModel.getSelectedItem('spaLocations', {});
                      var location = vm.location
                        vm.bookingWindowData[item.SpaItemId] = app.commonViewHelper.getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location,item))
                    }
                });
                var dfd =  new $.Deferred();
                resolveInSequence(pkgItemsArr,[]);
                return dfd.promise();
                function resolveInSequence(arr,res){
                    if(arr.length==0) return;
                    var item = arr[0];
                    if(!vm.bookingWindowData[item.SpaItemId]){
                     //   var location = app.models.spaModel.getSelectedItem('spaLocations', {});
                     var location = vm.location
                        vm.bookingWindowData[item.SpaItemId] = app.commonViewHelper.getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location,item))
                    };
                    params.SpaItemId = item.SpaItemId;
                    params.Refetch = refetch || false;
                    params.IsForPackageItem ="Y"
                    if(version==2) params.Version = "2";
                    if(version==2) params.SpaStaffId = '0';
                    var modelName = 'spaAvailability'+(version==2?'V2':'');
                    app.models.spaModel.getData(modelName, params).then(function(spaServicesData){ 
                        if(version==2) spaServicesData = spaServicesData.SpaAvailabilities[0];
                        if(!availabilities[item.SpaItemId]) availabilities[item.SpaItemId] = {};

                        spaServicesData.SpaAvailability = [].concat(spaServicesData.SpaAvailability).filter(function(avail){ return avail.StartTime.substring(0,10) == dateTime.substring(0,10) });
                        spaServicesData.SpaAvailability.forEach(function(avail){
                            var conflict = ( item.HasEquipment == "Y" && avail.AvailableEquipment == 0) || avail.AvailableRooms == 0;
                            var st = moment(avail.StartTime,'YYYY-MM-DDHHmmss');
                            var et = moment(st).add(item.ServiceTime,'minutes');
                            if(!conflict) conflict = vm.checkConflict(st,et,null,userId, package.SpaFolioItemIds, refetch, ignoreExistingItemConflict);
                            if(!conflict) conflict = !vm.checkBookable(item.SpaItemId,avail.StartTime);
                            if(!conflict) {
                                if(version==2){
                                    if(!staffObj[item.SpaItemId]) staffObj[item.SpaItemId] = {allStaff:{}};
                                    if(!resObj.staff[item.SpaItemId]) resObj.staff[item.SpaItemId] = {allStaff: {}};
                                    // staffObj[item.SpaItemId].allStaff
                                    [].concat(avail.SpaStaffs.SpaStaff).forEach(function(staff){
                                        staffObj[item.SpaItemId].allStaff[staff.SpaStaffId] = true;
                                        resObj.staff[item.SpaItemId].allStaff[staff.SpaStaffId] = true;
                                    })
                                    if(!staffObj[item.SpaItemId][avail.StartTime]) staffObj[item.SpaItemId][avail.StartTime] = [].concat(avail.SpaStaffs.SpaStaff).map(function(staff){ return _.extend(staff,package.components[item.SpaItemId].staff[staff.SpaStaffId], {isValid : false}) });

                                    resObj.staff[item.SpaItemId][avail.StartTime] = JSON.parse(JSON.stringify(staffObj[item.SpaItemId][avail.StartTime]));
                                }
                               if(!Array.isArray(availabilities[item.SpaItemId])) availabilities[item.SpaItemId] = [];
                               availabilities[item.SpaItemId].push(avail.StartTime);
                            }
                        });
                        if(arr.length==1){
                            var maxTimeInExistingBooking = false;
                            if(!existingBookings) existingBookings = [];
                            else {
                                existingBookings = _.sortBy(existingBookings,function(o){ return o.time });
                                var latestBooking = existingBookings.slice(-1)[0];
                                maxTimeInExistingBooking = moment(latestBooking.time,'YYYY-MM-DDHHmmss').add((package.components[latestBooking.itemid] || {}).duration,'minutes');
                            }
                            modifiedComponents = null;
                            if(existingBookings)
                                modifiedComponents = _.omit(package.components,existingBookings.map(function(booking){ return booking.itemid }));
                            else modifiedComponents = package.components
                            sort_levels = {}
                            _.values(modifiedComponents).forEach(function(item){
                                if(!sort_levels[item.sort]) sort_levels[item.sort] = [];
                                sort_levels[item.sort].push(item.itemid);
                            });
                            var sort_levels_without_0 = _.chain(sort_levels).keys().without('0').value()
                            var lowest_sort = sort_levels_without_0.length > 0 ? _.min(sort_levels_without_0) : 0;
                            var top_level_itemids = requiredItemID ? [requiredItemID] :sort_levels[lowest_sort].concat(sort_levels[0]);
                            var top_level_times = {};
                            _.each(availabilities,function(v,itemid){
                                if (top_level_itemids.indexOf(itemid)>=0) {
                                    _.each(v, function(x){
                                        top_level_times[x]=top_level_times[x]||[]
                                        if(top_level_times[x].indexOf(itemid)==-1)top_level_times[x].push(itemid)
                                    })
                                }
                            })
                            var lastPossibleEndTime = moment().startOf('day').format('YYYY-MM-DDHHmmss');
                            _.each(availabilities,function(timesArr,itemid){
                                _.each(timesArr, function(startTime){
                                    var endTime = moment(startTime,'YYYY-MM-DDHHmmss').add(package.components[itemid].duration,'m').format('YYYY-MM-DDHHmmss');
                                    lastPossibleEndTimesPerItem[itemid] = endTime;
                                    if(endTime > lastPossibleEndTime) {
                                        lastPossibleEndTime = endTime;
                                    }
                                })
                            })
                            var minTimeRequiredForAllServices = 0;
                            _.values(package.components).forEach(function(item){
                                minTimeRequiredForAllServices+= +item.duration;
                            });

                            var sortedTopLevelTimes = _.chain(top_level_times).keys().sort().value();
                            var lastPossibleStartTime = moment(lastPossibleEndTime,'YYYY-MM-DDHHmmss').subtract(minTimeRequiredForAllServices,'minutes').format('YYYY-MM-DDHHmmss');

                            sortedTopLevelTimes.filter(function(time){ return time <= lastPossibleStartTime; }).forEach(function(startTime) {
                                var itemids = top_level_times[startTime];
                                var top_level_time = startTime;
                                for (var j = 0; j < itemids.length; j++) {
                                    if(_.values(currentStartTimeNotPossibleForItems).filter(function(x){ return !x }).length == 0) break;
                                    var bool = true;
                                    var breakLoop = false;
                                    var unBookedActivityTime = moment(top_level_time,'YYYY-MM-DDHHmmss');
                                    if(maxTimeInExistingBooking){
                                        var timediff = unBookedActivityTime.diff(maxTimeInExistingBooking,'minutes');
                                        if(timediff < 0 || timediff > maxGap) bool = false;
                                    }
                                    if(bool){
                                        var current_candidate_staff = getStaffAsPerUserSelection(itemids[j], staffObj[itemids[j]][top_level_time]);
                                        for (var k=0;k<current_candidate_staff.length;k++) {
                                            if (a = search( existingBookings.concat([{ itemid: itemids[j],isTimePossible:true, time: top_level_time, duration:package.components[itemids[j]].duration,name:package.components[itemids[j]].itemName, staffId:current_candidate_staff[k].id, staffName:current_candidate_staff[k].name,
                                            gender:current_candidate_staff[k].gender }]), +lowest_sort)) {
                                                res.push(a);
                                                addStaffFromCombination(a)
                                                breakLoop = true;
                                                break;
                                            }
                                        }
                                    }
                                    if(breakLoop) break;
                                }
                            });
                            resObj.data = res;
                            dfd.resolve(resObj);
                        }
                        resolveInSequence(arr.slice(1),res)
                    },function (e) {
                        console.log("i ran in error",e)
                        dfd.reject({e:e});
                    })
                }

                function addStaffFromCombination(combination) {
                    combination.forEach(function(item){
                        if(!resObj.staff[item.itemid]) resObj.staff[item.itemid] = {allStaff: {}};

                        resObj.staff[item.itemid][item.time] = staffObj[item.itemid][item.time].map(function(staff){ return _.assign(staff, {isValid : true}) });
                        staffObj[item.itemid][item.time].forEach(function(staff){ resObj.staff[item.itemid].allStaff[staff.SpaStaffId] = true; });
                    })
                }

                function getStaffAsPerUserSelection (itemId, staffArr){
                    var userSelection = selectedStaffs[itemId].toUpperCase();
                    if(userSelection == 'X') return staffArr;
                    if(['M','F'].indexOf(userSelection) >- 1){
                        return staffArr.filter(function(staff){ return staff.gender == userSelection });
                    }
                    return staffArr.filter(function(staff){ return staff.SpaStaffId == userSelection });
                }

                function checkValidStaffCleanUp( prev_time, next_time ) {
                    if(prev_time.staffId == next_time.staffId) {
                        var cleanTime = (package.components[prev_time.itemid].staff[prev_time.staffId]||{}).cleanTime;
                        var prev_end_time = moment(prev_time.time,'YYYY-MM-DDHHmmss').add((package.components[prev_time.itemid] || {}).duration,'minutes');
                        var next_start_time = moment(next_time.time,'YYYY-MM-DDHHmmss');
                        var prev_end_time_after_clean = prev_end_time.add(cleanTime,'minutes');
                        return next_start_time.diff(prev_end_time_after_clean) >= 0 ? true : null;
                    }
                    return true;
                }
            
                function is_valid( prev_time, next_time ) {
                    var returnObj = {};
                    var pkg_max_gap = package.components[prev_time.itemid].max_gap || package.max_gap,
                        pkg_min_gap = package.components[prev_time.itemid].min_gap || package.min_gap,
                        end_time = moment(prev_time.time,'YYYY-MM-DDHHmmss').add(package.components[prev_time.itemid].duration,'minutes').add(package.components[prev_time.itemid].processTime,'minutes'),
                        max_time = moment(end_time).add(pkg_max_gap,'minutes'),
                        minTimeForNextServiceToStart = moment(end_time).add(pkg_min_gap,'minutes'),
                        nextTime = next_time,
                        next_time = moment(next_time.time,'YYYY-MM-DDHHmmss');

                    if(!!pkg_max_gap && max_time.diff(next_time) < 0) {
                        returnObj.reason = "failDueToMaxGap";
                        returnObj.status = false;
                    }else if(next_time.diff(end_time) < 0 || (!!pkg_min_gap && next_time.diff(minTimeForNextServiceToStart) < 0)) {
                        returnObj.reason = "breakStaff";
                        returnObj.status = false;
                    }else {
                        returnObj.status = checkValidStaffCleanUp(prev_time, nextTime);
                    }
                    return returnObj;
                }

                function search( history, current_sort ) {

                    var minTimeRequiredForRemainingServices = 0;

                    var idsToConsider = _.keys(package.components).filter(function(itemId){
                        return !history.some(function(historyItem){ return historyItem.itemid == itemId });
                    });

                    idsToConsider.forEach(function(itemId){ 
                        minTimeRequiredForRemainingServices+= +package.components[itemId].duration;
                    });

                    var lastPossibleEndTimeForRemaining = moment().startOf('day').format('YYYY-MM-DDHHmmss');
                    idsToConsider.forEach(function(itemId){
                        if(lastPossibleEndTimesPerItem[itemId] > lastPossibleEndTimeForRemaining) {
                            lastPossibleEndTimeForRemaining = lastPossibleEndTimesPerItem[itemId];
                        }
                    });

                    if(moment().startOf('day').format('YYYY-MM-DDHHmmss') == lastPossibleEndTimeForRemaining) { //the last item has been added to packages combination and there is nothing after this item.
                        lastPossibleEndTimeForRemaining = moment().endOf('day').format('YYYY-MM-DDHHmmss');
                    }

                    var lastPossibleStartTimeForRemaining = moment(lastPossibleEndTimeForRemaining,'YYYY-MM-DDHHmmss').subtract(minTimeRequiredForRemainingServices,'minutes').format('YYYY-MM-DDHHmmss');


                    if (history.length >= 2) {
                        validCheck = is_valid(history[history.length-2],history[history.length-1]);
                        if ( !validCheck.status ) {
                            return validCheck;
                        }
                    }

                    if (history.length == _.keys(availabilities).length) {
                        return history;
                    }

                    var candidates = _.difference( (sort_levels[current_sort]||[]).concat(sort_levels[0]||[]), _.map(history,'itemid') )
                    while (!candidates.length && current_sort<_.keys(sort_levels).length) {
                        current_sort += 1  //warning:needs all consecutive numbered keys to exist in sort_levels
                        candidates = _.difference( sort_levels[current_sort].concat(sort_levels[0]||[]), _.map(history,'itemid') )
                    }
                    // candidates == [ 1001, 1005 ]
                    for (var i=0;i<candidates.length;i++) {
                        var avails_to_consider = _.filter( availabilities[candidates[i]], function (x) {
                            x = moment(x,'YYYY-MM-DDHHmmss');
                            var endTime = moment(history[history.length-1].time,'YYYY-MM-DDHHmmss').add(package.components[history[history.length-1].itemid].duration,'minutes');
                            return x.diff(endTime) >= 0 && x.format('YYYY-MM-DDHHmmss') <= lastPossibleStartTimeForRemaining;
                            // return x >= +history[history.length-1].time + +package.components[history[history.length-1].itemid].duration
                        } );
                        if(avails_to_consider.length == 0) {
                            currentStartTimeNotPossibleForItems[candidates[i]] = true;
                            if(_.values(currentStartTimeNotPossibleForItems).filter(function(x){ return !x; }).length == 0) return false;
                        }
                        // todo filter avails_to_consider where gap is too large
                        for (var j=0;j<avails_to_consider.length;j++) {
                            var current_candidate = { itemid: candidates[i],isTimePossible:true, time: avails_to_consider[j], duration:package.components[candidates[i]].duration,name:package.components[candidates[i]].itemName };
                            var current_candidate_staff = getStaffAsPerUserSelection(current_candidate.itemid, staffObj[current_candidate.itemid][current_candidate.time]);
                            for (var k=0;k<current_candidate_staff.length;k++) {

                                current_candidate.staffId = current_candidate_staff[k].id;
                                current_candidate.staffName = current_candidate_staff[k].name;
                                current_candidate.gender = current_candidate_staff[k].gender;

                                var a = search( history.concat( current_candidate ), current_sort );
                                if(Array.isArray(a)){
                                    return a
                                } else if (a && a.status===false){
                                    if(a.reason == "failDueToMaxGap") return;
                                    if(a.reason == "breakStaff") break;
                                };
                            }
                        }
                    }
                    if (sort_levels[0] && !_.difference(candidates, sort_levels[0]).length && (history.length < _.keys(availabilities).length-sort_levels[0].length)) {
                        return search( history, current_sort+1 );
                    }
                    return false
                }
        },
        bringToViewport:function(elem){
            var bounding = elem.getBoundingClientRect();
 
            if(bounding.height > (window.pageYOffset)){
                window.scrollTo({top: bounding.height ,left: 0,behavior: 'smooth'})
            }
        },
        nl2br: function(value) {
            return value? (new showdown.Converter()).makeHtml(String(value)) :''
                // .replace(/\r?\n/g, '<br/>')
                /*.replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&apos;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');*/
    
        },
        fetchFutureBookingsForUser: function(groupCustomerId) {
            // initGuestItinerary: function () {
                var defer = $.Deferred(),
                    deferreds = [],
                    itinerarySources = [],
                    vm=this
              
                if(!groupCustomerId) return defer.resolve([]); //return empty array if user is not logged in.
                var res = [];
                var BookingCustomerId = groupCustomerId;
                if(groupCustomerId == app.data.CustomerId) groupCustomerId = null;
                app.customization.features.pmsBooking && itinerarySources.push({name:'pmsBooking', model:'fetchCustomerPMSBookings', data:'PMSBooking', date:'DepartureDate',reserved:'RESERV', completed:'CHKOUT', folioid:'PMSFolioId', customerID:'', folioItemId:'',displayName:'Hotel Reservation'});

                app.customization.features.spaBooking && itinerarySources.push({name:'spaBooking', model:'fetchCustomerSpaBookings', data:'SpaFolio', subitem:'SpaFolioItem', date:'BookStartTime', endtime:'BookEndTime', reserved:'BKD', completed:'COM', folioid:'SpaFolioId', customerID:'BookingCustomerId', folioItemId:'SpaFolioItemId'});

                app.customization.features.diningBooking && itinerarySources.push({name:'diningBooking', model:'fetchCustomerDiningReservations', data:'DiningReservation', date:'DateTime', /*reserved:'BKD', completed:'COM',*/ folioid:'SpaFolioId', customerID:'CustomerId', folioItemId:'DiningReservationId', customizationObjectId:'DiningVenue', displayName:'Dining Reservation'});
                //                                                                         /|\
                //  NOTE changed the name of diningBooking, so it will create app.data.diningFuture app.data.diningPast and app.data.dinings  (NOT app.data.diningBookingFuture, etc.)
                // {name:'skiBooking', model:'fetchCustomerSkiBookings', data:'SkiFolio', subitem:'SkiFolioItem', date:'BookStartTime', reserved:'BKD', completed:'COM', folioid:'SkiFolioId'}
                app.customization.features.golfBooking && itinerarySources.push({name:'golfBooking', model:'fetchCustomerGolfBookings', data:'GolfBooking', date:'BookingTime', folioid:'GolfBookingId', reserved:'BKD', completed:'COM', subitem:'GolfPlayer', customerID:'CustomerId', folioItemId:'GolfBookingId', customizationObjectId:'CourseId'});
                $.each(itinerarySources, function(i,itinerarySource){
                    var semaphore = $.Deferred();
                    deferreds.push(semaphore.promise());
                    var idToUse = groupCustomerId || app.data.CustomerId;
                    app.data.reservedTimes = app.data.reservedTimes || {};
                    app.data.reservedTimes[idToUse] = app.data.reservedTimes[idToUse] || {};
                    app.data.reservedTimes[idToUse][itinerarySource.name+'Future'] = [];
                    app.data.reservedTimes[idToUse][itinerarySource.name+'Past'] = [];
                    app.data.reservedTimes[idToUse][itinerarySource.name+'s'] = [];
                    if (app.data.CustomerId && app.data.CustomerGUID && app.customization.features[itinerarySource.name]) {
                        $.when(
                            app.models.userModel.getData(itinerarySource.model, {CustomerId:app.data.CustomerId,CustomerGUID:app.data.CustomerGUID,GroupCustomerId:groupCustomerId }),
                            app.customization.features.pmsBooking && (deferreds.length>1) && deferreds[0]
                        )
                            .done(function(r,r2){
                                if(!r[itinerarySource.data]){
                                    semaphore.resolve();
                                }else {
                                    if(!Array.isArray(r[itinerarySource.data])) r[itinerarySource.data] = [r[itinerarySource.data]]
                                    $.each(r[itinerarySource.data] || [], function(i,theBookingItem){
                                        var bookingItemArray = itinerarySource.subitem ? theBookingItem[itinerarySource.subitem] : theBookingItem,
                                            theDate=null;

                                        $.each($.isArray(bookingItemArray)?bookingItemArray:[bookingItemArray],function(j,bookingItem){
                                            if (itinerarySource.aggregateGolfPlayers && theBookingItem[itinerarySource.aggregateGolfPlayers]) {
                                                theBookingItem.golfPlayers = _.reduce(
                                                                    _.isArray(theBookingItem[itinerarySource.aggregateGolfPlayers])
                                                                    ? theBookingItem[itinerarySource.aggregateGolfPlayers]
                                                                    : [theBookingItem[itinerarySource.aggregateGolfPlayers]]
                                                                , function( aggregate, player ) {
                                                                    if (player.BookStatus!='CNL' && player.BookStatus!='NSH') {
                                                                        aggregate.players += 1
                                                                        aggregate.price += +player.ItemPrice
                                                                        aggregate.itemName = player.ItemName
                                                                        aggregate.courseId = player.CourseId
                                                                    }
                                                                    return aggregate
                                                                    }
                                                                , { players: 0, price: 0 }
                                                                )
                                            }
 
                                            if(!bookingItem[itinerarySource.date]) bookingItem[itinerarySource.date] = theBookingItem[itinerarySource.date];



                                            if (!bookingItem || ((!!itinerarySource.reserved||!!itinerarySource.completed) && (bookingItem.BookStatus != itinerarySource.reserved && bookingItem.BookStatus != itinerarySource.completed)) || !bookingItem[itinerarySource.date] || ((theDate = Date.parseExact(bookingItem[itinerarySource.date].substr(0,10).concat('235959'),"yyyy-MM-ddHHmmss")) === null)) {
                                                return;
                                            }
                                          
                                            if (theDate >= Date.now()) {
                                                if ( !!!bookingItem.BookStatus || bookingItem.BookStatus == itinerarySource.reserved){
                                                    app.data.reservedTimes[idToUse][itinerarySource.name+'Future'] = app.data.reservedTimes[idToUse][itinerarySource.name+'Future'] || [];
                                                    app.data.reservedTimes[idToUse][itinerarySource.name+'Future'].push(theBookingItem[itinerarySource.folioid]);
                                                    bookingItem.Future = true;
                                                 
                                                    if(!bookingItem[itinerarySource.folioid]) bookingItem[itinerarySource.folioid] = theBookingItem[itinerarySource.folioid];
                                                    if(!bookingItem[itinerarySource.folioItemId]) bookingItem[itinerarySource.folioItemId] = theBookingItem[itinerarySource.folioItemId];
                                                    if(!bookingItem.ItemName) bookingItem.ItemName = itinerarySource.displayName;

                                                    var pmsFolioExist = itinerarySource.name =="pmsBooking" && !res.some(function(item){ return item.folioid == bookingItem[itinerarySource.folioid] })

                                                    var otherBookingExist = !!(bookingItem[itinerarySource.customerID] == BookingCustomerId ) && !res.some(function(item){ return item.SpaFolioItemId == bookingItem[itinerarySource.folioItemId] })

                                        
                                                    if( otherBookingExist || pmsFolioExist ){
                                             
                                                       // res.push()
                                                       var bookingObj = {
                                                        StartTime:  itinerarySource.name !="pmsBooking" ? bookingItem[itinerarySource.date]:bookingItem.ArrivalDate,
                                                        EndTime: itinerarySource.name !="pmsBooking" ?(itinerarySource.endtime ? bookingItem[itinerarySource.endtime] : moment(bookingItem[itinerarySource.date],'YYYY-MM-DDHHmmss').add(app.customization[itinerarySource.name].defaultDurationPerLocation[theBookingItem[itinerarySource.customizationObjectId]],'minutes').format('YYYY-MM-DDHHmmss')):bookingItem.ArrivalDate,//for pms start and end date kept as arrival because later I will add end date per num of nights. Currently vue calender doesnt support extended stay
                                                        activity: bookingItem.ItemName,
                                                        SpaFolioItemId: bookingItem[itinerarySource.folioItemId],
                                                        LocationName:bookingItem[(vm.bookingResponseTemplate[itinerarySource.name].Label.Location)||itinerarySource.customizationObjectId],
                                                        GuestRequest :bookingItem[vm.bookingResponseTemplate[itinerarySource.name].Label.GuestRequest],
                                                        isFutureBooking: true,
                                                        formattedDateTime : moment(bookingItem[itinerarySource.date], 'YYYY-MM-DDHHmmss').format('ddd, MMM D @ hh:mm A'),
                                                        bookingType: itinerarySource.name
                                                    }

                                                    if(itinerarySource.name == "diningBooking"){
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.PartySize = bookingItem.PartySize
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.Reference = bookingItem.Reference
                                                    }
                                                    else if(itinerarySource.name == "golfBooking"){
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.Position = bookingItem.Position
                                                         vm.bookingResponseTemplate[itinerarySource.name].data.players = theBookingItem.golfPlayers.players
                                                    }
                                                    else if(itinerarySource.name == "spaBooking"){
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.Room = bookingItem.Room
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.ServiceTime = bookingItem.ServiceTime
                                                    }
                                                    else if(itinerarySource.name == "pmsBooking"){
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.Nights = bookingItem.Nights
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.NumAdults = bookingItem.NumAdults
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.NumChildren = bookingItem.NumChildren
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.NumYouth = bookingItem.NumYouth
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.PMSRoomNumber = bookingItem.PMSRoomNumber
                                                        vm.bookingResponseTemplate[itinerarySource.name].data.folioid =  bookingItem[itinerarySource.folioid]
                                                    }
                                                    _.extend(bookingObj,vm.bookingResponseTemplate[itinerarySource.name].data)
                                                    if (itinerarySource.name == "pmsBooking") {
                                                        var numOfNights = parseInt(bookingObj.Nights)
                                                        for (var i = 0; i < numOfNights; i++) {
                                                            var obj = _.assign({}, bookingObj)
                                                            obj.StartTime = moment(obj.StartTime, "YYYY-MM-DDHHmmss").add(i, 'days').format("YYYY-MM-DDHHmmss")
                                                            obj.EndTime = obj.StartTime
                                                            res.push(obj)
                                                        }
                                                  
                                                        return;
                                                    }
                                                    res.push(bookingObj)

                                                    }
                                                  
                                                } else {
                                                    return;
                                                }
                                            } 
                                            if(moment(bookingItem[itinerarySource.date].substr(0,10).concat('000000'),"YYYY-MM-DDHHmmss").diff(moment(),'minutes')<0) {
                                                if (bookingItem.BookStatus == itinerarySource.completed){
                                                    app.data.reservedTimes[idToUse][itinerarySource.name+'Past'] = app.data.reservedTimes[idToUse][itinerarySource.name+'Past'] || [];
                                                    app.data.reservedTimes[idToUse][itinerarySource.name+'Past'].push(theBookingItem[itinerarySource.folioid]);
                                                    theBookingItem.Past = true;
                                                } else {
                                                    return;
                                                }
                                            }
                                            bookingItem.date = theDate;
                                            if (theBookingItem.DailyRateDetails) {
                                                var dailyRateDetails = $.firstOrOnly(theBookingItem.DailyRateDetails);
                                                theBookingItem.PMSRateType = dailyRateDetails.PMSRateType;
                                                theBookingItem.PMSRateId = dailyRateDetails.PMSRateId;
                                            }
                                            if (_.any(app.data.pmsDayBookings,function(x){return x==theBookingItem.PMSFolioId})) {
                                                theBookingItem.isDayBooking = true;
                                            }
                                            if (!app.data.reservedTimes[idToUse][itinerarySource.name+'s']) {
                                                app.data.reservedTimes[idToUse][itinerarySource.name+'s'] = []
                                            }
                                            if (itinerarySource.subitem) {
                                                var slicedBookingItem = $.extend( {}, theBookingItem );
                                                slicedBookingItem[itinerarySource.subitem] = $.extend( {}, bookingItem );
                                                app.data.reservedTimes[idToUse][itinerarySource.name+'s'].push( slicedBookingItem );
                                            } else {
                                                app.data.reservedTimes[idToUse][itinerarySource.name+'s'].push( theBookingItem );
                                            }
                                        });
                                        if (app.data.RestrictedFolio) {
                                            app.data.reservedTimes[idToUse][itinerarySource.name + 'Past'] = []
                                            if (itinerarySource.name == "pmsBooking") {
                                                // app.data[itinerarySource.name + 'Future'] = _.filter(app.data[itinerarySource.name + 'Future'], function (bookingItem) {
                                                //     return bookingItem[itinerarySource.folioid] == app.data.RestrictedFolio
                                                // })
                                            } else {
                                                app.data.reservedTimes[idToUse][itinerarySource.name + 'Future'] = _.filter(app.data.reservedTimes[idToUse][itinerarySource.name + 'Future'], function (bookingItemId) {
                                                    var bookingItem = _.find(app.data.reservedTimes[idToUse][itinerarySource.name+'s'],function(x){return x[itinerarySource.folioid]==bookingItemId})
                                                    bookingItem = (bookingItem && bookingItem[itinerarySource.subitem]) ? bookingItem[itinerarySource.subitem] : bookingItem;
                                                return bookingItem && bookingItem[itinerarySource.date].substr(0, 10) >= app.data.restrictedFolioStartDate.toString("yyyy-MM-dd") &&
                                                    bookingItem[itinerarySource.date].substr(0, 10) <= app.data.restrictedFolioEndDate.toString("yyyy-MM-dd")
                                                })
                                            }
                                        }
                               
                                    })
                                    console.log('done semaphore',semaphore);
                                    semaphore.resolve();
                                }
                            })
                            .fail(function(r){
                                app.data.reservedTimes[idToUse][itinerarySource.name+'s'] = [];
                                app.data.reservedTimes[idToUse][itinerarySource.name+'s'].noData = true;
                                console.log('fail semaphore',semaphore);
                                semaphore.resolve();
                            });
                    } else {
                        app.data.reservedTimes[idToUse][itinerarySource.name+'s'] = [];
                        semaphore.resolve();
                    }
                })

                $.when.apply(this,deferreds).done(function(){
                    defer.resolve(res);
                }).fail(function(){
                    // defer.resolve(res);
                    defer.reject([])
                });
                return defer.promise();
            // }
        },
        setExistingFolioBookingsToDifferentUser: function(existingFolioBookings,userId){
            if(!userId) userId = app.data.CustomerId;
            // $.when(app.models.systemModel.getData('folioBookings', {})).then(function (folioItems) {
            //     var webFolioItems = folioItems.WebFolioItem || []
            //     performInSeries(webFolioItems);
            // });
            performInSeries(existingFolioBookings);

            function performInSeries(arr){
                if(arr.length == 0) {
                    return;
                }
                var folioItem = arr.pop();
                app.models.spaModel.getData('updateSpaFolioItemCustomer', {
                    SpaFolioItemId: folioItem.FolioItemId,
                    CustomerId: userId
                }).then(function(){
                    performInSeries(arr);
                })
            }
        },
        setStoreFromUrl: function(){
            var vm = this; //TODO: change confusing variable name
            var endLoop = false;
            var configFromUrl_IsEmpty = true;
            var services = {};
            var dfd = $.Deferred();
            this.promiseRef = dfd.promise();

            if(vm.configFromUrl.activeStep == 'Edit') {
                store.commit('setEditingFolioItemId',vm.configFromUrl.selectionId);
            }
            if(!!this.configFromUrl.date){
                var date = moment(this.configFromUrl.date,'YYYY-MM-DD').format(app.localization.spaBooking.packageBooking.stepper.body.schedule.dateBarDaysFormat)
                if(date!= store.state.selectedDateOnDateBar) store.commit('setselectedDateOnDateBar',{date:date,doNotUpdate:true});
                configFromUrl_IsEmpty = false;
            }

            if(!!this.configFromUrl.activeStep){
                store.commit('setActiveStep',{step:this.configFromUrl.activeStep,doNotUpdate:true});
                configFromUrl_IsEmpty = false;
            }


            this.fetchSpaClassesAndPackages().then(function(spaServicesData){
                store.commit('removeAllCategories');
                _.sortBy(spaServicesData.services, function(service){ return service.name.toLowerCase() }).forEach(function(service){
                    service.value.forEach(function(serviceItem){ store.commit('addCapableStaffToService',serviceItem);})
                    var category = service.name;
                    if(!!category){
                        store.commit('addCategory',{name:category});
                        services[category]=service.value;
                    }
                });
                if(store.state.allCategories.indexOf(store.state.activeCategory)==-1){
                    store.commit('setActiveCategory',{category:store.state.allCategories[0]});
                    if(app.customization.googleAnalytics){
                        vm.analyticsInit('setActiveCategory',[store.state.allCategories[0], store.state.services])
                    }
                }
                
                store.commit('addAllServices',services);
                store.commit('addAllPackages',spaServicesData.packages);
                _.keys(store.state.users).forEach(function(userId){
                    _.keys(store.state.users[userId]).forEach(function(itemId){
                        var package = spaServicesData.packages[itemId.split('-')[0]];
                        if(!!package){
                            store.commit('addDataToPackagesFromFolio',{ userId:userId, itemId:itemId, package:package });
                        }
                    })
                })

                if(!!vm.configFromUrl.categoryFilter){
                    store.commit('setSelectedCategoryFilter',{filter:vm.configFromUrl.categoryFilter,doNotUpdate:true});
                    configFromUrl_IsEmpty = false;
                }

                if(!!vm.configFromUrl.category){
                    store.commit('setActiveCategory',{category:vm.configFromUrl.category,doNotUpdate:true});
                    if(app.customization.googleAnalytics){
                        vm.analyticsInit('setActiveCategory',[vm.configFromUrl.category, store.state.services])
                    }
                    configFromUrl_IsEmpty = false;
                }

                if(configFromUrl_IsEmpty){
                    store.commit('setSelectedCategoryFilter',{filter:store.state.selectedCategoryFilter});
                }

                if(!!vm.configFromUrl.selectionId && vm.configFromUrl.activeStep != 'Edit'){
                    var service = _.find(services[vm.configFromUrl.category], function(el){ return el.SpaItemId == vm.configFromUrl.selectionId})
                    // var mutation = isNaN(vm.configFromUrl.selectionId) ? 'setActiveCategory' : 'setActiveService';
                    store.commit('setActiveService',{id:vm.configFromUrl.selectionId,doNotUpdate:true});
                    if(Customization.spaBooking.onetimeBookerLocations && _.isArray(Customization.spaBooking.onetimeBookerLocations) && Customization.spaBooking.onetimeBookerLocations.indexOf(app.data["selected/spa/spaLocations/SpaLocation/"]) > -1){
                        store.commit('addService',{service:service,userId:_.keys(store.state.users)[0],setSelected:true});
                        setTimeout(function(){
                            $("a[href='#" + vm.configFromUrl.selectionId + "']").click()
                        }, 1000)
                    }
                    
                    configFromUrl_IsEmpty = false;
                }
                dfd.resolve();

            });
        },
        matchStoreWithFolio: function() {
            var spaFolioIds = {};
            this.fetchFolioBookings().then(function(data) {
				_.values(data.formatted).forEach(function(item) {
                    if(store.state.OTBactive && Object.keys(store.state.users)[0] != item.CustomerId) return;
                    if(app.customization.sideCart.showOnAllModules || item.Category == "Spa"){
                        spaFolioIds[item.FolioItemId] = true;
                        store.commit("addServiceFromFolio", {
                            service: item,
                            userId: item.CustomerId
                        });
                        if(item.FolioItemId == store.state.editingFolioItemId && store.state.status == 'E') { //edit mode
                            var userIndexInUsersObj = _.keys(store.state.users).indexOf(item.CustomerId);
                            _.values(store.state.users[item.CustomerId]).forEach(function(service,index){
                                if(service.SpaFolioItemId == store.state.editingFolioItemId) {
                                    store.commit('changeActiveService',{id:index,user:userIndexInUsersObj, allow:true });
                                }
                            });
                        }
                    }
				});
				_.keys(store.state.users).forEach(function(userId){
					_.keys(store.state.users[userId]).forEach(function(serviceId){
						var service = store.state.users[userId][serviceId];
						if(!!service.SpaFolioItemId && !spaFolioIds[service.SpaFolioItemId]){
                            store.commit('removeSingleService',{ userId:userId, id:serviceId });
                            store.commit('removeReservedTime',{ userId:userId, FolioItemId:service.SpaFolioItemId });
						}
					})
				})
			});
        },
        // Login-vue-app helpers
        checkEmail: function (email) {
            var dfd = $.Deferred();
            app.models.userModel
              .getData('checkCustomerEmail', { EmailAddress: email })
              .then(
                function (r_ce) {
                  dfd.resolve(false);
                },
                function (err) {
                  dfd.resolve(true);
                }
              );
            return dfd.promise();
          },
          validEmail: function (email) {
            return /^[^@"(),:;<>\/\[\\\]|`]+@[a-z0-9-]+(\.?[a-z0-9-])*\.[a-z0-9]{2,}$/i.test(
              email
            );
          },
          authenticateUser: function (email, password, eventName,urlParameter) {
            this.dispatch(
              'profile',
              'authenticate',
              encodeURIComponent(email),
              encodeURIComponent(password),
              eventName,
              urlParameter
            );
          },
          dispatch: function (module, action) {
            var params = Array.from(arguments).slice(2);
            app.dispatcher.dispatch(module, action, params);
          },
          getOptions: function (options) {
            return _.map(options, function (value, optionName) {
              return { name: optionName, val: value };
            });
          },
          performPasswordComplexityCheck: function (password) {
            // Get Pw complexity from backend, compare and show right width
            var result = '',
              score = '',
              bar = $('#password-strength-meter'),
              progressHelperText = '',
              dfd2 = $.Deferred();
            require(['lib/zxcvbn'], function (zxcvbn) {
              (result = zxcvbn(password)), (score = result.score);
            //Calulate diff with the scor for relative width 
                var requiredScore = app.data.minPasswordStrength;
                var diff = (requiredScore - (parseFloat(score)));
                //lowest width when no password
                if(password === '') {
                    diff = 1000;
                }
                if(password.length < 8) {
                    progressHelperText = app.localization.newUser.passwordComplexityMessages.short;
                    diff = 1000;
                }
                switch (true) {
                    case (diff > 3):
                    $(bar)
                        .attr('class', 'progress-bar progress-bar-danger')
                        .css('width', '5%');
                        if(password.length > 8) {
                            progressHelperText = app.localization.newUser.passwordComplexityMessages.tooGuessable;
                        }
                    break;
                    case (diff > 2 && diff <= 3):
                    $(bar)
                        .attr('class', 'progress-bar progress-bar-danger')
                        .css('width', '25%');
                        progressHelperText = app.localization.newUser.passwordComplexityMessages.veryGuessable;
                    break;
                    case (diff > 1 && diff <= 2):
                    $(bar)
                        .attr('class', 'progress-bar progress-bar-warning')
                        .css('width', '50%');
                        progressHelperText = app.localization.newUser.passwordComplexityMessages.someWhatGuessable;
                    break;
                    case (diff > 0 && diff <= 1):
                    $(bar)
                        .attr('class', 'progress-bar progress-bar-info')
                        .css('width', '75%');
                        progressHelperText = Localization.newUser.passwordComplexityMessages.fairlyStrong;
                    break;
                    case (diff <= 0):
                    $(bar)
                        .attr('class', 'progress-bar progress-bar-success')
                        .css('width', '100%');
                        progressHelperText = app.localization.newUser.passwordComplexityMessages.met;
                    break;
                }
                dfd2.resolve(diff, progressHelperText);
            });
            return dfd2.promise();
          },
          createUser: function (params, isGuestUser) {
            // creates user/guest
            //processes data from template
            _.each(params, function (value, paramName) {
              paramName[paramName] = encodeURIComponent( value || '');
            });
            // getting usertype to make the right dispatch
            var type = app.data.userType;
            $('#progressIndicator').modal('show');
            this.dispatch(
              'profile',
              (type == 'member' ? 'membercreatesubmit' : (isGuestUser ? 'createGuestSubmit' : 'createsubmit')),
                params.email,
                //Guest users have no password
                (params.isGuestUser ? '' : params.password),
                params.gender,
                params.salutation,
                params.firstName,
                params.lastName,
                params.phoneType && params.phoneType.substr(0, 1),
                params.homePhone,
                params.workPhone,
                params.workExt,
                params.otherPhone,
                params.mobilePhone,
                params.addressFirst,
                params.addressSecond,
                params.city,
                params.province,
                params.country,
                params.postalCode,
                params.otherAddressFirst || '',
                params.otherAddressSecond || '',
                params.otherCity || '',
                params.otherProvince || '',
                params.otherCountry || '',
                params.otherPostalCode || '',
                params.newsLetter,
                params.mailMarketing,
                params.phoneMarketing,
                params.smsMarketing,
                params.language || 'English',
                params.clubAddress ||'',
                params.clubMemberList || '',
                params.clubListPhone || '',
                params.clubListEmail || '',
                params.userSkiSize || '',
                params.userSkiBootSize || '',
                params.userSkierType || '',
                params.userCustomerType || '',
                params.userSnowboardSize || '',
                params.userSnowboardBootSize || '',
                params.userDinNumber || '',
                params.userAge || '',
                params.userWeight || '',
                params.userHeight || '',
                params.dob || ''
            );
          },
        searchReservation: function(lastName, folioNumber) {
        //searches for a reservation
        //additional check
          if(lastName && folioNumber){
            // folioid, lastname, eventName, emailaddress
            $('#progressIndicator').modal('show');
            this.dispatch('profile', 'authenticatefolio', encodeURIComponent(folioNumber), encodeURIComponent(lastName), 'folioEvent', '')
           }
        },
        handleForgotPw: function(email){
            if(email){
                $('#progressIndicator').modal('show');
                app.dispatcher.dispatch('profile', 'doreset', [encodeURIComponent(email), 'loginResetPasswordCustomer'])
            }
        },
        capitalize_Words: function (str)
        {
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        },
        escapeRegex: function (string) {
            return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
        replaceHtml: function (vueComponent, targetString, newString) {
            vueComponent.template = vueComponent.template.replace(targetString, newString);
        },
        injectHtml: function (vueComponent, beforeString, injectString) {
            var templateString = vueComponent.template.replace(injectString, '');
            var indexToAppend = templateString.indexOf(beforeString);
            vueComponent.template = "".concat(templateString.substring(0, indexToAppend), injectString, templateString.substring(indexToAppend));
        }
    }
})

;
